// Clinical heuristic: window preset is determined by the FINDING leaf (the 2nd
// path segment), NOT the organ prefix. Same organ can contain both lung-window
// findings (atelectasis) and soft-tissue ones (pleural effusion).
// Pending radiologist review before production use.

import { WINDOW_PRESETS, PresetConfig, WindowPreset } from "../constants/windowPresets";

// Lung-parenchyma findings: use lung window (W:1500, C:-600).
export const LUNG_LEAF_KEYWORDS = [
  "atelectasis",
  "pneumothorax",
  "consolidation",
  "emphysema",
  "ground_glass",
  "pulmonary_nodule",
  "bronchiectasis",
  "pulmonary_opacity",
  "pulmonary_mass",
] as const;

// Osseous findings: use bone window (W:1800, C:400).
export const BONE_LEAF_KEYWORDS = [
  "fracture",
  "lytic",
  "blastic",
  "osseous",
  "bone_lesion",
  "stone",
  "calculus",
  "calculi",
] as const;

// Everything else (pleural effusion, ascites, abscesses, lymph nodes, hepatic,
// pericardial effusion, etc.) → soft_tissue (W:400, C:40).

const byId = (id: WindowPreset): PresetConfig => WINDOW_PRESETS.find((p) => p.id === id)!;

/**
 * Derive the window preset for a finding given its full condition path.
 * Matches on the leaf (2nd segment), e.g. `lungs_pleura_diaphragm/simple_pleural_effusion`
 * → leaf `simple_pleural_effusion` → soft_tissue.
 */
export function presetForFinding(condition: string): PresetConfig {
  const leaf = condition.split("/")[1] ?? "";
  if (LUNG_LEAF_KEYWORDS.some((kw) => leaf.includes(kw))) return byId("lung");
  if (BONE_LEAF_KEYWORDS.some((kw) => leaf.includes(kw))) return byId("bone");
  return byId("soft_tissue");
}
